/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { DocumentEditPropertiesPanel } from "cms/documents/document-selector/dialog-edit/panels/document-edit-panel-properties";
import { DocumentEditDialogTopActions } from "cms/documents/document-selector/dialog-edit/actions/document-dialog-top-actions";
import { DocumentEditRecordsManagementPanel } from "./document-edit-panel-records-management";
import { DocumentEditPlacementsPanel } from "./document-placement-panel";

const DocumentEditPanel = () => {
    
    return (
        <Fragment>
            <DocumentEditDialogTopActions />
            <div className='edit-doc-panel edit-document'>
                <DocumentEditPropertiesPanel />
                <DocumentEditRecordsManagementPanel />
                <DocumentEditPlacementsPanel />
            </div>
        </Fragment>
    );
};

export { DocumentEditPanel };
